import { observer } from "mobx-react"
import React from "react"
import "../../App.less"
import { DataLayerFn } from "../../Configs/API"
import BenefitStore from "../../Configs/Store/benefit"
import FormStore from "../../Configs/Store/forms"
import AppStore from "../../Configs/Store/index"
import "../../styles/Benefits/Benefit.less"
import CarousalModal from "../Common/CarousalModal"
import { scrollToClass } from "../Common/CommonFunctions"
import DynamicCard from "../Common/DynamicCard"
import BenefitHeadText from "../Common/GenericComponenetHeader"
import JSON from "../../Configs/JSON/Benefits.json"
import DOMPurify from "dompurify"

const Benefits = observer(() => {
  const device = AppStore.device

  const closeAllBenModal = (e) => {
    BenefitStore.setModalMode(false)
    // window. ViewAllBenefits_PopupClose

    var tempButtonText = window.sfaf432dgsjgsdjlasjklgfhaklfkhajkncaskhh
    // console.info("DataLayer tempButtonText", e)
    var typeButtonCross = e === undefined ? "Check Returns" : "X"
    var isFloatBen = AppStore.mainFooter ? "Benefits_floating_close" : "PlanBenefits_ViewAll_Close"
    var sectionText = AppStore.mainFooter ? "Benefits Floating" : "View All Benefits"
    if (device === 0) {
      DataLayerFn("PlanBenefits_PopupClose||Calculator-Landing page|Plan Benefits", FormStore, "", typeButtonCross, tempButtonText, "")
    } else {
      DataLayerFn(`${isFloatBen}||Calculator-Landing page|${sectionText}`, FormStore, "", "X", "", "")
    }
  }

  // const closeAllBenMobModal = (e) => {
  //   var optionText = ""
  //   var buttonText = e === undefined ? "Check Returns" : "X"
  //   if (e !== undefined) {
  //     var target = e.target.closest(".DynamicCardModalWrapper")

  //     if (target !== null)
  //       optionText = target.querySelector(".DynamicCardTitleModal").innerHTML

  //     optionText = optionText.replace(/<\/?[^>]+(>|$)/g, "")
  //     if (optionText.includes("&amp;"))
  //       optionText = optionText.split("&amp;")[1]

  //     // console.info("DATALAYER TRACE :", optionText)
  //   }

  //   BenefitStore.setAddBenefitModal(false)
  //   // window. ViewAllBenefits_PopupClose
  //   DataLayerFn(
  //     "OnlineBenefits_PopupClose||Calculator-Landing page|Online Benefits",
  //     FormStore,
  //     "",
  //     buttonText,
  //     optionText,
  //     ""
  //   )
  // }

  const ctaButtonClick = (e, btnClickedFrom) => {
    let optionText = ""
    let eventName = btnClickedFrom === "Benefits" ? "PlanBenefits" : "OnlineBenefits"
    if (btnClickedFrom === "Benefits") optionText = BenefitStore.selectedBenefit

    if (e !== undefined) {
      var target = e.target.closest(".DynamicCardModalWrapper")

      if (target !== null) optionText = target.querySelector(".DynamicCardTitleModal").innerHTML

      optionText = optionText.replace(/<\/?[^>]+(>|$)/g, "")
      if (optionText.includes("&amp;")) optionText = optionText.split("&amp;")[1]

      // console.info("DATALAYER TRACE :", optionText)
    }
    var tempButtonText = window.sfaf432dgsjgsdjlasjklgfhaklfkhajkncaskhh
    DataLayerFn(eventName + "_CalculatePension||Calculator-Landing page|" + btnClickedFrom, FormStore, "", "Check Returns", tempButtonText, "")
    if (btnClickedFrom === "Benefits") BenefitStore.setModalMode(false)
    else if (btnClickedFrom === "Online Benefits") BenefitStore.setAddBenefitModal(false)
    // benefitAction.setAddBenefitModal(false)
  }

  // const validateFormByBenMob = (e) => {
  //   ctaButtonClick(e, "Online Benefits")
  //   setTimeout(async () => {
  //     scrollToClass("CalculatorCard")
  //     document.querySelector(".CalculatorCard .calculateFormButton").click()
  //   }, 500)
  // }

  const validateFormByBen = (e) => {
    ctaButtonClick(e, "Benefits")
    setTimeout(() => {
      scrollToClass("CalculatorCard")
      document.querySelector(".CalculatorCard .calculateFormButton").click()
    }, 500)
  }

  let benifitContainer = null
  let benifitContainerOnlyPC = null
  let benifitandTitleContainer = null
  let cardContents = JSON.cardContents
  let modalCardContent = JSON.cardContents
   let addModalContent = JSON.addBenefit
  // BHT
  let handleCardClick = null
  // Card
  let cardWrapperStyle = null
  let cardTitleStyle = null
  let cardContentStyle = null
  let cardDotStyle = null
  let arrowUrl = null
  let cardArrowStyle = null
  let cardIconStyle = null
  let titleBodyWrapperStyle = "DynamicCardTitleBodyWrapper"
  const benefitsCardContentsPc = JSON.cardContentPcSix
  if (device === 0) {
    benifitContainer = "benifitsMobileContainer"
    benifitContainerOnlyPC = null
    benifitandTitleContainer = "benifitandTitleContainerMob RogueContent"
    cardContents = JSON["cardContentsMob"]
    modalCardContent = JSON["cardContentsMob"]
    addModalContent = JSON["addBenefit"]

    // Card
    handleCardClick = async (i, e) => {
      var target = e.target.closest(".DynamicCardMobileWrapper")
      var buttonText = ""
      if (target !== null) buttonText = target.querySelector(".DynamicCardTitleMobile").innerHTML

      buttonText = buttonText.replace(/<\/?[^>]+(>|$)/g, "")
      // console.info("DataLayer E :", buttonText)

      DataLayerFn("PlanBenefits_Selected||Calculator-Landing page|Plan Benefits", FormStore, "", "", buttonText, "")

      await BenefitStore.setModalMode(true)
      await BenefitStore.setCardId(i)
      // window. PlanBenefits_Selected
      DataLayerFn("PlanBenefits_PopupOpen||Calculator-Landing page|Plan Benefits", FormStore, "", "", buttonText, "")
      window.sfaf432dgsjgsdjlasjklgfhaklfkhajkncaskhh = buttonText
    }
    cardWrapperStyle = "DynamicCardMobileWrapper"
    cardTitleStyle = "DynamicCardTitleMobile"
    arrowUrl = JSON.icons.arrowMob
    cardArrowStyle = "arrowMobileDC"
    cardDotStyle = "DynamicCardDotMobile"
  } else {
    benifitContainer = "benifitsPCContainer"
    benifitandTitleContainer = "BHTMain RogueContent"
    benifitContainerOnlyPC = "benifitContainerOnlyPC"
    cardContents = JSON["cardContentsPC"].slice(0,6)
    modalCardContent = JSON["cardContentsPC"]
    addModalContent = JSON["addBenefit"]

    // Card
    cardWrapperStyle = "DynamicCardPCWrapper"
    cardTitleStyle = "DynamicCardTitlePC"
    cardArrowStyle = "arrowPCsm"
    cardDotStyle = "DynamicCardDotPC"
    cardContentStyle = "DynamicCardBodyPC"
    arrowUrl = JSON.icons.arrowPc
  }

  const handleModalShow = async () => {
    await BenefitStore.setModalMode(true)
    DataLayerFn("PlanBenefits_ViewAll||Calculator-Landing page|View All Benefits", FormStore, "", "View all benefits", "", "")
    setTimeout(() => {
      DataLayerFn("PlanBenefits_ViewAll_Open||Calculator-Landing page|View All Benefits", FormStore, "", "", "", "")
    }, 100)
  }

  const closeAllBenMobModal = (e) => {
    var optionText = ""
    var buttonText = e === undefined ? "Check Returns" : "X"
    if (e !== undefined) {
      var target = e.target.closest(".DynamicCardModalWrapper")

      if (target !== null) optionText = target.querySelector(".DynamicCardTitleModal").innerHTML

      optionText = optionText.replace(/<\/?[^>]+(>|$)/g, "")
      if (optionText.includes("&amp;")) optionText = optionText.split("&amp;")[1]

      // console.info("DATALAYER TRACE :", optionText)
    }

    BenefitStore.setAddBenefitModal(false)
    // window. ViewAllBenefits_PopupClose
    DataLayerFn("OnlineBenefits_PopupClose||Calculator-Landing page|Online Benefits", FormStore, "", buttonText, optionText, "")
  }

  const validateFormByBenMob = (e) => {
    console.info("Clicked From", "Online Benefits")
    // closeAllBenMobModal()
    ctaButtonClick(e, "Online Benefits")
    setTimeout(async () => {
      scrollToClass("CalculatorCard")
      document.querySelector(".CalculatorCard .calculateFormButton").click()
    }, 500)
  }

  const BenefitsContentPC = () => {
    return (
      <>
        {benefitsCardContentsPc.map((x, i) => (
          <DynamicCard
            key={i}
            data={x}
            dot={true}
            arrow={true}
            title={true}
            content={false}
            icon={true}
            onClick={(e) => handleCardClick(i, e)}
            expandable={true}
            wrapperStyle={"DynamicCardPCWrapper"}
            titleStyle={"DynamicCardTitlePC"}
            contentStyle={cardContentStyle}
            dotStyle={"DynamicCardDotPC"}
            arrowUrl={JSON.icons.arrowPc}
            arrowStyle={"arrowPCsm"}
            // iconStyle={cardIconStyle}
            titleBodyWrapperStyle={"DynamicCardTitleBodyWrapper"}
            dataLayerEvent={"PlanBenefit_Selected|" + (x.title + "").replace(/<\/?[^>]+(>|$)/g, "")}
            />
        ))}
      </>
    )
  }
  const BenefitsContentMOBILE = () => {
    return (
      <>
        {cardContents.map((x, i) => (
          <DynamicCard
          key={i}
          data={x}
          dot={true}
          arrow={false}
          title={true}
          content={false}
          icon={true}
          onClick={(e) => handleCardClick(i, e)}
          expandable={true}
            wrapperStyle={"DynamicCardMobileWrapper"}
            titleStyle={"DynamicCardTitleMobile"}
            // contentStyle={cardContentStyle}
            dotStyle={"DynamicCardDotMobile"}
            arrowUrl={JSON.icons.arrowMob}
            arrowStyle={"arrowMobileDC"}
            // iconStyle={cardIconStyle}
            titleBodyWrapperStyle={"DynamicCardTitleBodyWrapper"}
            dataLayerEvent={"PlanBenefit_Selected|" + (x.title + "").replace(/<\/?[^>]+(>|$)/g, "")}
          />
        ))}
      </>
    )
  }

  return (
    <>
    {/* Mobile */}
    <div className="benifitandTitleContainerMob">
        <div className="benefitTnC" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(JSON.tnc) }}></div>
        <div className="benifitsMobileContainer">
          <BenefitsContentMOBILE />
        </div>
        {/* </div> */}
      </div>

      {/* Desktop */}
      <div >
        <div className="benifitContainerOnlyPC">
          <BenefitHeadText
            content={JSON.BHTTitleText}
            icon={false}
            BHTContainer={"BHTContainer noCursorPointer"}
            onClick={() => {
              DataLayerFn("OnlineBenefits_Selected||Calculator-Landing page|Online Benefits", FormStore, "", "Buy online & get up to 2% Additional Benefit~", "", "")
            BenefitStore.setAddBenefitModal(true)
            DataLayerFn("OnlineBenefits_PopupOpen||Calculator-Landing page|Online Benefits", FormStore, "", "Buy online & get up to 2% Additional Benefit~", "", "") }}
          />
          <div className="benifitContainerTitle">{JSON["BenefitWrapperTitle"]}</div>
          <div className="benifitsPCContainer">
            <BenefitsContentPC />
          </div>
          <div className="benefitHypWrapper">
            {/* <div className="benefitConditionsApply">
              <sup>^</sup>Conditions Apply
            </div> */}
            <div className="benifitContainerHyp" onClick={handleModalShow}>
              {JSON["BenefitWrapperFooter"]}
            </div>
          </div>
        </div>
        <div className="benefitTnCPC" > <sup>^</sup>Conditions Apply</div>
      
      </div>
      <CarousalModal
          cardContents={JSON["cardContentsMob"]}
          title={AppStore.device === 0 ? JSON["benefitModalTitle"] : JSON.benefitModalTitlePC}
          visibleState={BenefitStore.modalMode}
          updateVisibility={closeAllBenModal}
          rootClassName={"BenefitModalRoot"}
          buttonShow={AppStore.device === 0 ? true : false}
          buttonText={JSON.buttons.benefitsMobModal}
          buttonClick={validateFormByBen}
          footer={AppStore.device === 1 ? JSON.tnc : null}
          forceRender={true}
        />
      {/* additional Benefits Modal  */}
        <CarousalModal
          cardContents={ JSON["addBenefit"]}
          title={JSON["addBenefitModalTitle"]}
          visibleState={BenefitStore.addBenefitModal}
          updateVisibility={closeAllBenMobModal}
          rootClassName={"addBenefitModalRoot"}
          buttonShow={AppStore.device === 0 ? true : false}
          buttonText={JSON.buttons.benefitsMobModal}
          buttonClick={validateFormByBenMob}
          forceRender={true}
        />  
  </>
  )
})
export default Benefits
